const initImageAccordion = () => {
    const accordionItemList = document.querySelectorAll("[data-accordion-item]");
    if (accordionItemList && accordionItemList.length > 0) {
        const imageElement = document.querySelector("[data-img]");
        let urlSrc;
        let imageAlt;
        const setImage = (inputItem, outputItem) => {
            urlSrc = inputItem.getAttribute("data-src");
            imageAlt = inputItem.getAttribute("data-alt");
            outputItem.setAttribute("src", urlSrc);
            outputItem.setAttribute("alt", imageAlt);
        };
        for (let index = 0; index < accordionItemList.length; index++) {
            const item = accordionItemList[index];
            if (index === 0) {
                item.classList.add("active");
                setImage(item, imageElement);
            }
            item.addEventListener("click", () => {
                setImage(item, imageElement);
            });
        }
    }
};
